import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";

import "./assests/css/style.css";
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
import 'bootstrap/dist/js/bootstrap.min.js'


// pages for this product
import Chat from "./views/Chat.js";


global.jQuery = require('jquery');
require('bootstrap');


var hist = createBrowserHistory();

ReactDOM.render(
  <Router history={hist} >
    <Switch>
      <Route path='*'  component={Chat} />
    </Switch>
  </Router>,
  document.getElementById("root")
);
